import { IUserDetail } from "../interface/user-detail";
export class UserClinic {
  constructor(
    public AssociateId: number,
    public AssociateClinicId: number,
    public AssociateUserId: number,
    public AssociateClinicName: string
  ) {}
}
export class UserAccount {
  constructor(
    public UserId: number,
    public BankName: string,
    public BranchName: string,
    public AccountNo: string,
    public IFSCCode: string,
    public AccountName: string
  ) {}
}
export class UserDetail implements IUserDetail {
  constructor(
    public UserId: number,
    public UserName: string,
    public UserPassword: string,
    public UserRePassword: string,
    public UserRole: string,
    public UserRoleId: number,
    public FirstName: string,
    public LastName: string,
    public Gender: string,
    public ContactNo: number,
    public UserAddress: string,
    public Email: string,
    public ImagePath: string,
    public FacebookProfile: string,
    public LinkedInProfile: string,
    public UserType: string,
    public SpecializationId: number,
    public SpecializationText: string,
    public Type: string,
    public OrganizationId: number,
    public OrganizationName: string,
    public UserClinic: UserClinic[],
    public ColorCode: string,
    public GooglePlusProfile: string,
    public InstagramProfile: string,
    public VideoPath: string,
    public City: string,
    public Experience: string,
    public Biography: string,
    public AccountDetail?: UserAccount,
    public TwitterProfile?: string,
    public UserPlan?: string,
    public UserWebsite?: string,
    public IsDeleted?: number,
    public CountryID?: number,
    public StateId?: number,
    public CountryCode?: number,
    public UserServices?: any,
    public UserActive?: number,
    public UserUrl?: string,
    public IsShow?: number,
    public CommType?: string,
    public CommAmt?: number,
    public Timezone?: string
  ) {}
}
export class PaymentModeOption {
  constructor(
    public Path: String,
    public ModeType: string,
    public Value: string
  ) {}
}

export class DashboardData {
  constructor(
    public ExpertCount: number,
    public UsersCount: number,
    public Completed: number,
    public Missed: number,
    public Canceled: number,
    public Total: number,
    public LiveCount: number
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/section/user/model/user-detail.ts